exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#url[data-v-5b85639e] {\n  border-radius: 0;\n}\n", ""]);

// exports
